import MuiCircularProgress from '@mui/material/CircularProgress';
import { css } from '@emotion/react';

import { makeStyles } from '@toolbox/style';
import { useProgress } from './useProgress';
import MuiThemeProvider from '@widget/toolbox/style/theme/common/ThemeProvider';
import { BREAKPOINTS, useBreakpoint } from '@widget/utils/useBreakpoint';

const THICKNESS = 3.5;
const SIZE_MOBILE = 40;
const SIZE_DESKTOP = 80;

const useStyles = makeStyles(({ theme }) => ({
  container: css`
    display: grid;
    place-items: center;
  `,
  text: css`
    grid-area: 1 / -1 / 1 / -1;
    font-size: 10px;
    line-height: ${theme.lineHeights.sm};
    color: ${theme.palette.colors.petrol[400]};

    ${theme.media.up('md')} {
      font-size: ${theme.fontSizes.f1};
    }
  `,
  progress: css`
    grid-area: 1 / -1 / 1 / -1;
  `,
  progressBackground: css`
    color: ${theme.palette.colors.gray[300]};
  `,
  progressActive: css`
    color: ${theme.palette.colors.petrol[400]};
  `,
  containeasdr: css`
    display: flex;
    flex-direction: column;
    padding: ${theme.spacing(2)};

    ${theme.media.up('md')} {
      padding-top: ${theme.spacing(8)};
    }
  `,
}));

export function CircularProgress() {
  const value = useProgress();
  const styles = useStyles();

  const breakpoint = useBreakpoint() || '';
  const isMobile = [BREAKPOINTS.xs, BREAKPOINTS.sm].includes(breakpoint);
  const size = isMobile ? SIZE_MOBILE : SIZE_DESKTOP;

  return (
    <MuiThemeProvider>
      <div css={styles.container as any}>
        <MuiCircularProgress
          css={[styles.progress, styles.progressBackground] as any}
          variant="determinate"
          value={100}
          thickness={THICKNESS}
          size={size}
        />
        <MuiCircularProgress
          css={[styles.progress, styles.progressActive] as any}
          variant="determinate"
          value={value}
          thickness={THICKNESS}
          size={size}
        />
        <span css={styles.text as any}>{`${Math.round(value || 0)}%`}</span>
      </div>
    </MuiThemeProvider>
  );
}
